"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.default = (function (entry, global) {
    if (global === void 0) { global = window; }
    var m = new Map();
    var heap = [];
    function encounterFunction(func) {
        var found = m.get(func);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(func, id);
        var value = {
            name: func.name,
            body: Function.prototype.toString.call(func),
            proto: Object.getPrototypeOf(func).constructor.name,
        };
        heap.push({ type: 'function', value: value });
        return id;
    }
    function encounterPlainObj(plainObj) {
        var found = m.get(plainObj);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(plainObj, id);
        var refArray = [];
        heap.push({ type: 'object', value: refArray });
        for (var key in plainObj) {
            if (Object.prototype.hasOwnProperty.call(plainObj, key)) {
                refArray.push({
                    key: serializeValue(key),
                    value: serializeValue(plainObj[key]),
                });
            }
        }
        return id;
    }
    function encounterArr(arr) {
        var e_1, _a;
        var found = m.get(arr);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(arr, id);
        var refArray = [];
        heap.push({ type: 'array', value: refArray });
        try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var v = arr_1_1.value;
                refArray.push(serializeValue(v));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return id;
    }
    function encounterSetOrMap(map, type) {
        var e_2, _a;
        var found = m.get(map);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(map, id);
        var refArray = [];
        heap.push({ type: type, value: refArray });
        try {
            for (var _b = __values(map.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
                refArray.push({
                    key: serializeValue(k),
                    value: serializeValue(v),
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return id;
    }
    function encounterDate(date) {
        var found = m.get(date);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(date, id);
        heap.push({ type: 'date', value: date.getTime() });
        return id;
    }
    function encounterRegex(regex) {
        var found = m.get(regex);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(regex, id);
        var value = {
            src: regex.source,
            flags: '',
        };
        if (regex.global)
            value.flags += 'g';
        if (regex.ignoreCase)
            value.flags += 'i';
        if (regex.multiline)
            value.flags += 'm';
        heap.push({ type: 'regexp', value: value });
        return id;
    }
    function encounterError(error) {
        var found = m.get(error);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(error, id);
        var value = {
            name: error.name,
            message: error.message,
            stack: error.stack,
        };
        heap.push({ type: 'error', value: value });
        return id;
    }
    function encounterArrBuff(buff) {
        var found = m.get(buff);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(buff, id);
        var view = new Int8Array(buff);
        var value = Array.prototype.slice.call(view);
        heap.push({ type: 'arraybuffer', value: value });
        return id;
    }
    function encounterTypedArray(view, ctor) {
        var found = m.get(view);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(view, id);
        var value = {
            ctor: ctor,
            viewArr: Array.prototype.slice.call(view),
        };
        heap.push({ type: 'typedarray', value: value });
        return id;
    }
    function encounterSymbol(sym) {
        var found = m.get(sym);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(sym, id);
        var value = sym.toString().slice(7, -1);
        heap.push({ type: 'symbol', value: value });
        return id;
    }
    function encounterDOMNode(node) {
        var found = m.get(node);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(node, id);
        var serializer = new window.XMLSerializer();
        var value = serializer.serializeToString(node);
        heap.push({ type: 'domnode', value: value });
        return id;
    }
    function encounterNodeList(nodeList) {
        var found = m.get(nodeList);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(nodeList, id);
        var refArray = [];
        heap.push({ type: 'nodelist', value: refArray });
        Array.prototype.forEach.call(nodeList, function (node) {
            refArray.push(serializeValue(node));
        });
        return id;
    }
    function encounterHtmlCollection(collection) {
        var found = m.get(collection);
        if (found) {
            return found;
        }
        var id = heap.length;
        m.set(collection, id);
        var refArray = [];
        heap.push({ type: 'htmlcollection', value: refArray });
        Array.prototype.forEach.call(collection, function (node) {
            refArray.push(serializeValue(node));
        });
        return id;
    }
    function serializeValue(obj) {
        var e_3, _a;
        switch (typeof obj) {
            case 'undefined': {
                heap.push({ type: 'undefined', value: '' });
                return heap.length - 1;
            }
            case 'string': {
                heap.push({ type: 'string', value: obj });
                return heap.length - 1;
            }
            case 'number': {
                if (obj !== obj) {
                    heap.push({ type: 'nan', value: '' });
                }
                else if (obj === global.Infinity) {
                    heap.push({ type: 'infinity', value: '+' });
                }
                else if (obj === -global.Infinity) {
                    heap.push({ type: 'infinity', value: '-' });
                }
                else if (1 / obj === -Infinity) {
                    heap.push({ type: 'neg0', value: '' });
                }
                else {
                    heap.push({ type: 'number', value: obj });
                }
                return heap.length - 1;
            }
            case 'boolean': {
                heap.push({ type: 'boolean', value: obj });
                return heap.length - 1;
            }
            case 'bigint':
                heap.push({ type: 'bigint', value: obj.toString() });
                return heap.length - 1;
            case 'symbol':
                return encounterSymbol(obj);
            case 'function':
                return encounterFunction(obj);
            case 'object': {
                if (obj === null) {
                    heap.push({ type: 'null', value: '' });
                    return heap.length - 1;
                }
                if (obj instanceof global.Map) {
                    return encounterSetOrMap(obj, 'map');
                }
                if (obj instanceof global.Set) {
                    return encounterSetOrMap(obj, 'set');
                }
                if (obj instanceof global.Date) {
                    return encounterDate(obj);
                }
                if (obj instanceof global.RegExp) {
                    return encounterRegex(obj);
                }
                if (obj instanceof global.Error) {
                    return encounterError(obj);
                }
                if (obj instanceof global.ArrayBuffer) {
                    return encounterArrBuff(obj);
                }
                try {
                    for (var typedArrTypes_1 = __values(types_1.typedArrTypes), typedArrTypes_1_1 = typedArrTypes_1.next(); !typedArrTypes_1_1.done; typedArrTypes_1_1 = typedArrTypes_1.next()) {
                        var type = typedArrTypes_1_1.value;
                        if (obj instanceof global[type]) {
                            return encounterTypedArray(obj, type);
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (typedArrTypes_1_1 && !typedArrTypes_1_1.done && (_a = typedArrTypes_1.return)) _a.call(typedArrTypes_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                if (obj instanceof global.Array) {
                    return encounterArr(obj);
                }
                if (obj instanceof global.Node) {
                    return encounterDOMNode(obj);
                }
                if (obj instanceof global.NodeList) {
                    return encounterNodeList(obj);
                }
                if (obj instanceof global.HTMLCollection) {
                    return encounterHtmlCollection(obj);
                }
                return encounterPlainObj(obj);
            }
            default:
                throw new Error('Unkown type');
        }
    }
    serializeValue(entry);
    var result = {};
    for (var i = 0; i < heap.length; i++) {
        result[i] = heap[i];
    }
    return result;
});
//# sourceMappingURL=preserve.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@replit/alcor/dist/preserve.js
// module id = 28
// module chunks = 0